module.exports = __webpack_public_path__ + "img/tertiary_11x1_z18.48a1652b.svg";